var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { attrs: { "data-no-prevent": "true" } },
    [
      _vm._l(_vm.guideSteps, function(step, index) {
        return [
          _c(
            "guide-step",
            _vm._b(
              {
                attrs: {
                  index: index,
                  selectedOption:
                    index < _vm.guideSteps.length - 1
                      ? _vm.guideSteps[index + 1].id
                      : ""
                },
                on: { fetchStep: _vm.fetchStep }
              },
              "guide-step",
              step,
              false
            )
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }